// import { createApp } from 'vue'
// import App from './App.vue'

// createApp(App).mount('#app')
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toast from './components/Toast.vue';


import './assets/css/global.css'


Vue.config.productionTip = false

/** 
 * 全局注册吐司提示框 
 * 使用示例
this.$toast.show({ message: '操作成功' });
this.$toast.show({ message: '提交失败，请重试', type: 'error', duration: 3000 });
this.$toast.show({ message: '注意：即将超时', type: 'warning', showClose: true, duration: 0 });
 * */
const ToastConstructor = Vue.extend(Toast);
const toastInstance = new ToastConstructor().$mount();
document.body.appendChild(toastInstance.$el);

Vue.prototype.$toast = {
  show: (options) => toastInstance.show(options),
  close: () => toastInstance.closeToast()
};


/**  
 * 全局挂载滚动定位方法   
 * 使用方法
 * <a href="#" @click.prevent="$scrollToRefById('global-contact-us', {}, true)">Contact Us</a>
*/
Vue.prototype.$scrollToRefById = function (targetKey, options = {}, isId = false) {
  const defaultOptions = { behavior: 'smooth', block: 'start' };
  const finalOptions = { ...defaultOptions, ...options };

  let targetSection = null;

  if (isId) {
    // 方式1：通过 id 查找（支持任意层级内嵌组件）
    targetSection = document.getElementById(targetKey);
    console.log(`通过 id 查找 DOM：`, targetSection);
  } else {
    // 方式2：兼容原有通过 ref 查找（当前组件内的 ref）
    targetSection = this.$refs[targetKey];
    console.log(`通过 ref 查找 DOM：`, targetSection);
  }

  if (targetSection) {
    targetSection.scrollIntoView(finalOptions);
  } else {
    const type = isId ? 'id' : 'ref';
    console.error(`未找到 ${type} 为 "${targetKey}" 的元素！`);
  }
};

/**
 * 回退到上一个页面
 * 调用示例
 * 
 * <!-- 按钮点击回退 -->
<button @click="$goBack()">返回上一页</button>
 */
Vue.prototype.$goBack = function () {
  // 可选优化：如果没有上一页（history.length <= 1），默认跳转到首页（避免回退到浏览器空白页）
  if (window.history.length <= 1) {
    this.$router.push('/'); // 需确保项目使用 Vue Router
  } else {
    window.history.back();
  }
};


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
